import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../Assets/Davids_court_Logo-1.png';
import { TiThMenuOutline } from "react-icons/ti";

const Header = () => {
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const isActive = (path) => location.pathname === path ? 'active-link' : '';

  return (
    <div>
      <header>
        <nav>
          <Link to='/'><img src={logo} alt="dclogo" className="logo" /></Link>
          <ul className={menuOpen ? 'active' : ''}>
            <li><Link to="/" className={isActive('/')}>Home</Link></li>
            <li><Link to="/about" className={isActive('/about')}>Who we are</Link></li>
            <li><Link to="/events" className={isActive('/events')}>Events</Link></li>
            <li><Link to="/ministries" className={isActive('/ministries')}>Ministries</Link></li>
            <li><Link to="/resources" className={isActive('/resources')}>Resources</Link></li>
            <li><Link to="/contact" className={`aaa ${isActive('/contact')}`}>Contact Us</Link></li>
          </ul>
          <button onClick={toggleMenu} className='menuicon'><TiThMenuOutline /></button>
        </nav>
      </header>
    </div>
  );
};

export default Header;
